export interface GalleryItem {
  src: string
  alt: string
  caption: string
  tag: string
}

export const gallery: GalleryItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/1XrUTvHgGsCxV7rnMEMfUU/image.png',
    alt: 'Asphalt shingle roof heavily covered in green moss before cleaning',
    caption: 'Moss-covered shingles before treatment',
    tag: 'Roof cleaning',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ogxyPBpiDNuJSNW4K41dSx/image.png',
    alt: 'Clean asphalt shingle roof after moss removal treatment',
    caption: 'Same roof, moss cleared',
    tag: 'Roof cleaning',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wCsr2HW2E5JPzcJghZPf1X/image.png',
    alt: 'Stone and siding home with a freshly washed paver driveway still wet',
    caption: 'Paver driveway and entry wash',
    tag: 'Driveways',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4s2P821h4fvdQL2pu5VeXK/image.png',
    alt: 'Technician using a water-fed pole to clean second story windows',
    caption: 'Upper-story glass, pole-fed and streak free',
    tag: 'Window cleaning',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/vYweuFjosPFyBZXrc4tpBi/image.png',
    alt: 'Technician on a ladder cleaning interior windows in a community dining room',
    caption: 'Interior glass at a senior community',
    tag: 'Commercial',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/r8gDWq7CeDKpHBugTWBzHV/image.png',
    alt: 'Large red metal barn with white doors after a full exterior wash',
    caption: 'Farm building washed top to bottom',
    tag: 'Commercial',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8dTcp5QXFVgFaTBtm5suuq/image.png',
    alt: 'Freshly washed composite deck with patio furniture overlooking a pond',
    caption: 'Composite deck washed and rinsed',
    tag: 'Decks',
  },
]
